module.exports = new __parcel__URL__("success-badge.7bb32b31.svg").toString();